import { render, staticRenderFns } from "./Finance-expense-create.vue?vue&type=template&id=55f43d48&"
import script from "./Finance-expense-create.vue?vue&type=script&lang=js&"
export * from "./Finance-expense-create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports